import { useEffect, useState } from 'react';
import { getReservations, getReservationsBySearch, getBlocks } from '../../../services/reservation';
import { normalizeDocumentNumber } from "../../../utils/inputValidations";

const useReservations = (type) => {
  const [data, setData] = useState([]);
  const [params, setParams] = useState({});
  const [pagination, setPagination] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null)

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const changeLoading = (loading) => {
    setIsLoading(loading);
  };

  const fetchReservations = async () => {
    try {
      if (!Object.keys(params).length) return;
      if (params.from === 'byDate' && (!params.department_id && !params.branch_office_id)) return;
      setIsLoading(true);

      const customParams = params;
      if (customParams.query) {
        customParams.query = normalizeDocumentNumber(customParams.query)
      }
      if (params.from === 'byDate' && type === 'confirmed') {
        customParams['counting'] = true;
      }

      let promises
      if (params.from === 'byDate') {
        promises = [getReservations({ ...customParams, page: currentPage })];
      } else {
        promises = [getReservationsBySearch({ ...customParams, page: currentPage })];
      }
      if (params.from === 'byDate' && type === 'confirmed') {
        promises.push(getBlocks(params));
      }

      const responses = await Promise.all(promises);
      const [reservationResponse, blockResponse] = responses;
      if (params.from === 'byDate' && type === 'confirmed') {
        blockResponse && setData(blockResponse);
        setPagination({ total: reservationResponse[0]['count'] });
      } else {
        setData(reservationResponse.data);
        setPagination(reservationResponse.pagination);
      }
    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, [params, currentPage, type])

  return {
    data,
    error,
    params,
    setParams,
    currentPage,
    changePage,
    changeLoading,
    isLoading,
    pagination
  };
};

export default useReservations;